export default [
  {
    id: 'f1bathroom-id',
    value: '1',
    label: '1',
    tracking: 'ga-search-form-toggle-1-bathroom',
    cy: 'bathroom-1'
  },
  {
    id: 'f2bathroom-id',
    value: '2',
    label: '2',
    tracking: 'ga-search-form-toggle-2-bathroom',
    cy: 'bathroom-2'
  },
  {
    id: 'f3bathroom-id',
    value: '3',
    label: '3',
    tracking: 'ga-search-form-toggle-3-bathroom',
    cy: 'bathroom-3'
  },
  {
    id: 'f4morebathroom-id',
    value: '3more',
    label: '+3',
    tracking: 'ga-search-form-toggle-3more-bathroom',
    cy: 'bathroom-3more'
  }
];
